import { createContext, useContext } from 'react';

import type { TSizes, TOnCloseHandler } from '../modal/models';

interface IModalContext {
    handleClose: VoidFunction | TOnCloseHandler;
    size: TSizes;
}

export const ModalContext = createContext<IModalContext>({
    handleClose: /* istanbul ignore next */ () => {},
    size: 'xl',
});

export const useModalContext = () => useContext(ModalContext);
